// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cloud_logic': 'enable',
    'aws_cloud_logic_custom': [{"id":"5xnm43muod","name":"ServerlessReactExampleCRUD","description":"","endpoint":"https://5xnm43muod.execute-api.eu-west-2.amazonaws.com/Development","region":"eu-west-2","paths":["/ServerlessReactExample","/ServerlessReactExample/123"]}],
    'aws_cognito_identity_pool_id': 'eu-west-2:59bf6dae-c7ea-4454-85f4-a1a5c77f4a2c',
    'aws_cognito_region': 'eu-west-2',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'serverlesswebappexam-hosting-mobilehub-1099236211',
    'aws_content_delivery_bucket_region': 'eu-west-2',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd2x9wan2jbunv.cloudfront.net',
    'aws_dynamodb': 'enable',
    'aws_dynamodb_all_tables_region': 'eu-west-2',
    'aws_dynamodb_table_schemas': [{"tableName":"serverlesswebappexam-mobilehub-1099236211-AWSMobileTable","attributes":[{"name":"teamId","type":"S"},{"name":"personId","type":"S"},{"name":"email","type":"S"},{"name":"personName","type":"S"},{"name":"phone","type":"S"}],"indexes":[{"indexName":"personName-index","hashKey":"teamId","rangeKey":"personName"}],"region":"eu-west-2","hashKey":"teamId","rangeKey":"personId"},{"tableName":"serverlesswebappexam-mobilehub-1099236211-ServerlessReactExample","attributes":[{"name":"ID","type":"S"},{"name":"ItemDescription","type":"S"},{"name":"ItemName","type":"S"},{"name":"ItemPrice","type":"N"}],"indexes":[],"region":"eu-west-2","hashKey":"ID"}],
    'aws_google_app_permissions': 'email,profile,openid',
    'aws_google_web_app_id': '847404625747-kj2ppqfv33rmg7cmgivumc743ugrnn1k.apps.googleusercontent.com',
    'aws_mobile_analytics_app_id': 'b90c53ca5b8945e0967a16c9d02a3554',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'd5a0b2d5-4825-4ac1-9869-3555c142bd3c',
    'aws_project_name': 'serverless-web-app-example',
    'aws_project_region': 'eu-west-2',
    'aws_resource_bucket_name': 'serverlesswebappexam-deployments-mobilehub-1099236211',
    'aws_resource_name_prefix': 'serverlesswebappexam-mobilehub-1099236211',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'eu-west-2_CYhVOvoME',
    'aws_user_pools_mfa_type': 'ON',
    'aws_user_pools_web_client_id': '534pq2ie0bq5f3mo4jro1brsuf',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js